module.exports = __webpack_public_path__ + "components/Profile/assets/user-numbers-mediakit.3e4622fc84bd1107f8a252934c5b99e3.png";